import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function SnackbarActionText({ className, children }) {
    return (
        <div
            className={cn(
                'opacity-50 text-[10px] font-medium tracking-[0.58px] uppercase leading-tight pt-0.5',
                className,
            )}
        >
            {children}
        </div>
    );
}

SnackbarActionText.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
